import styled from "styled-components";

export const DropdownContainer = styled.div`
  margin: 1rem 0;
`;

export const Card = styled.div`
  background: var(--color-white);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 0.375rem;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
    font-size: 12px;

  tr:first-child td {
    border-top: none;
  }
  
  td:first-child {
    font-weight: 600;
  }
`;
